import { Injectable } from '@angular/core'
import { Router } from "@angular/router"
import { Apollo } from 'apollo-angular'
import { Observable, BehaviorSubject, throwError, of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import gql from 'graphql-tag'

import { BaseService } from './base.service'
import { NotificationsService } from './notifications.service'
import { StatusService } from './status.service'

@Injectable()
export class ApolloService extends BaseService {

  private pendingRequests: number = 0;
  public isLoading: BehaviorSubject<boolean> = new BehaviorSubject(false)

  constructor(
    private apollo: Apollo,
    private router: Router,
    private status: StatusService,
    private notificationServ: NotificationsService
  ){
    super()
    console.log('ApolloService constructor', this.getId())
  }

  query(query: string, variables?: any) {
    return this.doRequest(this.apollo.query({
      query: gql(query),
      variables: variables
    }))
  }

  mutate(mutation: string, variables?: any, useMultipart: boolean = false) {
    return this.doRequest(this.apollo.mutate({
      mutation: gql(mutation),
      variables: this.removeTypename(variables),
      context: { useMultipart }
    }))
  }

  doRequest(observable: Observable<any>) {
    this.incPendingRequests()
    return observable
      .pipe(catchError(val => {
        this.handleError(val)
        return of({})
      }))
      .pipe(map(ret => {
        this.decPendingRequests()
        return ret
      }))
  }

  private handleError(err: any) {
    // console.error('catchError:', Object.keys(err))
    // console.log('Error:', JSON.stringify(err))
    console.log('graphQLErrors:', err.graphQLErrors)
    console.log('"networkError":', err.networkError)
    console.log('"message":', err.message)
    console.log('""extraInfo"":', err.extraInfo)
    const errors = err.graphQLErrors
    let code = errors && errors.length && errors[0].extensions && errors[0].extensions.code
    let exception = errors && errors.length && errors[0].extensions && errors[0].extensions.exception
    let message = err.message

    if(err.networkError && err.networkError.error && err.networkError.error.errors && err.networkError.error.errors.length) {
      message = err.networkError.error.errors[0].message
      code = err.networkError.error.errors[0].extensions && err.networkError.error.errors[0].extensions.code
    }

    if(err.graphQLErrors && err.graphQLErrors[0]) {
      message = err.graphQLErrors[0].message
    }

    if(err.networkError || code === 'INTERNAL_SERVER_ERROR' || code === 'constraint-violation' || code === 'BAD_USER_INPUT') {
      this.notificationServ.notifyError({ title: code || '', message, msgCod: exception && exception.msgCod })
      // this.router.navigate([''])
    }

    if(code === 'UNAUTHENTICATED') {
      this.notificationServ.notifyError({ title: code || '', message, msgCod: exception && exception.msgCod })
      this.status.logout()
    }
    if(code === 'FORBIDDEN') {
      if(!/^\/login/.test(this.router.url)) {
        this.notificationServ.notifyError({ title: code, message })
        this.status.logout()
      } else {
        this.status.cleanStorages()
      }
    }
  }


  private incPendingRequests() {
    this.pendingRequests++;
    // console.log('pendingRequests+', this.pendingRequests)
    this.isLoading.next(this.pendingRequests > 0);
  }

  private decPendingRequests() {
    this.pendingRequests--;
    // console.log('pendingRequests-', this.pendingRequests)
    this.isLoading.next(this.pendingRequests > 0);
  }

  private removeTypename = (value: any) => {
      if (value === null || value === undefined) {
        return value;
      } else if (Array.isArray(value)) {
        return value.map(v => this.removeTypename(v));
      }  else if (value instanceof Date) {
        return value;
      } else if (value instanceof File) {
        return value;
      } else if (typeof value === 'object') {
        const newObj = {};
        Object.entries(value).forEach(([key, v]) => {
          if (key !== '__typename') {
            newObj[key] = this.removeTypename(v);
          }
        });
        return newObj;
      }
      return value;
    };

}
